export default "__VITE_ASSET__51ac9369__"